import CardFilter from "../dashboard/CardFilter";

const SpamSearchBox = () => {
    return (
        <div className="w-full flex justify-center px-10 pb-5">
            <CardFilter
                dropDownItems={[
                    "User ID",
                    "userName",
                    "Hashtag",
                    "Country",
                    "community",
                    "Words",
                    "Date"
                ]}
                style={{ width: "100%", maxWidth: "400px" }}
                showFullTitle
            />
        </div>
    );
};

export default SpamSearchBox;
